<template>
  <div class="Friend">
    <van-nav-bar title="通讯录" fixed border>
      <template #right>
			<van-popover v-model="show" theme="dark" trigger="click" :offset="[14,0]" placement="bottom-end" @select="selPopover" :actions="actions">
			  <template #reference>
				  <van-icon name="weapp-nav" size="20px"/>
			  </template>
			</van-popover>
      </template>
    </van-nav-bar>

    <van-cell-group>
      <div class="addf">
        <img class="img" src="../../assets/img/icon/map-marked.png" />
        <van-cell to="/NewFriends" title="新朋友">
          <van-tag round type="danger" v-if="newFriends != 0">{{newFriends}}</van-tag>
          <span v-else>{{newFriends}}</span>个
        </van-cell>
      </div>
      <div class="addf" @click="onClickToGroup">
        <img class="img" src="../../assets/img/icon/friend1.png" />
        <van-cell title="群聊" :value="groupCount+'个'" />
      </div>
      <!-- <div class="addf" @click="onClickService">
        <img class="img" src="../../assets/img/icon/kefu1.png" />
        <van-cell title="联系客服" value />
      </div>-->
    </van-cell-group>
    <!-- 代理层级 -->
    <van-index-anchor v-for="(item, index) in friends" :key="index+'a'">
      <div class="indexWord" v-if="item.length > 0">{{index}}</div>
      <vs-tree :data="item" :props="props" icon-class :node-key="props.u_id">
        <span slot-scope="{ node, data }" @click="onFriendInfo(data.u_id)">
          <img :src="attach_url+data.u_headportrait" width="40px" height="40px" alt />
          <span class="username">{{data.u_nickname?data.u_nickname:data.u_login_id}}</span>
        </span>
      </vs-tree>
    </van-index-anchor>

  </div>
</template>
<script type='text/ecmascript-6'>
var pinyin = require("js-pinyin");
pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
import { FirstPin } from "@/utils/common.js";
import { Popover } from 'vant';
export default {
	name: "Friend",
	components:{
		"van-popover":Popover
	},
	data() {
		return {
			FirstPin: FirstPin,
			friends: [],
			agent: "",
			url: this.Conf.registUrl,
			u_code: "",
			show: false,
			newFriends: "0",
			groupCount: "",
			attach_url: this.Conf.serverPre,
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			group_manage: localStorage.getItem("group_manage"),
			treeData: [],
			props: {
				u_id: "u_id",
				label: "u_login_id",
				children: "child",
				u_headportrait: "u_headportrait",
				isLeaf: "isLeaf"
			},
			nodeKey: "",
			msgshowList:JSON.parse(localStorage.getItem("msgshowLists")),
			chkWebsocketTimer:false,
			actions: [
				{ text: '邀请朋友', icon: 'invition' },
				{ text: '发起群聊', icon: 'chat' }
			]
		};
	},
	created() {
	
		
		if (!this.u_id) {
			this.$router.push({
				path: "/login"
			});
		}
		this.getStateConfigs();
		this.loadData();
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		loadData() {
			var params = {
				u_id: this.u_id,
				token: this.token,
				num: Math.random()
			};
			var url = this.Conf.serverUrl + "Friends/index?num=" + Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				  var friend = response.data.friends;
				  var firstName = {};
				  this.FirstPin.forEach(item => {
					firstName[item] = [];
					friend.forEach(el => {
						let first = (el.f_name.f_name ? el.f_name.f_name : el.u_nickname ? el.u_nickname : el.u_login_id ).substring(0, 1);
						if (/[a-z]/.test(first) || /^[\u4e00-\u9fa5]*$/.test(first)) {
							first = pinyin.getCamelChars(el.f_name.f_name ? el.f_name.f_name : el.u_nickname ? el.u_nickname : el.u_login_id )
							.substring(0, 1)
							.toUpperCase(); // 英文
						} else {
							first = "#";
						}
						if (first == item) {
							firstName[item].push(el);
						}
					});
				  });
				  this.friends = firstName;
				  this.newFriends = response.data.newFriendCount;
				  this.groupCount = response.data.groupCount;

			})
			.catch(error => {});
		},
		// 顶部+号
		onClickRight(){
			this.show = true;
			// 查询当前登录id是否是代理
			var par = {
				u_id: this.u_id,
				token: this.token,
				num: Math.random()
			};
			var url = this.Conf.serverUrl + "User/selectAgentById";
			this.$axios
			.post(url, this.$qs.stringify(par))
			.then(response => {
				this.agent = response.data.result;
				this.u_code = response.data.u_code;
			})
			.catch(error => {
			});
		},
		selPopover(act,ind){
			if(act.icon=="invition"){
				this.addFriend();
			}else if(act.icon=="chat"){
				this.groupChat();
			}
		},
		// 邀请朋友
		addFriend() {
			// this.$toast("复制成功,去分享给好友吧！");
			this.$router.push({
				name: "Code",
				query: {
					actionName: "Friend"
				}
			});
		},
		// 复制成功
		onCopy(e) {},
		// 复制失败
		onError(e) {
		  this.$toast.fail("失败");
		},
		// 发起群聊
		groupChat() {
			this.$router.push({
				name: "AddGroupChat",
				query: {
					actionName: "Friend"
				}
			});
		},
		// 查看朋友信息
		onFriendInfo(id) {
			this.$router.push({
				name: "UserInfo",
				query: {
					friend_id: id,
					url: "Friend",
					active: 2
				}
			});
		},
		// 查看当前登录用户所在全部群
		onClickToGroup() {
			this.$router.push({
				name: "GroupInfo",
				query: {
					u_id: this.u_id
				}
			});
		},
		onClickService() {
			this.$router.push({
				path: "/Service"
			});
		},
		// 获取下级代理下的用户列表
		getusers(agent_id) {
			var par = {
				u_id: this.u_id,
				token: this.token,
				u_agent_id: agent_id,
				num: Math.random()
			};
			var url = this.Conf.serverUrl + "Friends/index";
			this.$axios
			.post(url, this.$qs.stringify(par))
			.then(response => {
				switch (response.data.code) {
					case 200:
						console.log(response.data.friends);
						var friends = response.data.friends;

						break;
					case 40001:
					  break;
				}
			})
			.catch(error => {
			  // console.log(error);
			});
		}
  
	},
	beforeDestroy: function () {
	}
};
</script>


// WEBPACK FOOTER //
// src/components/AddressList/Friend.vue